import { ValidatorFn, AbstractControl } from "@angular/forms";

export function helpURLValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        let reason: string = '';
        let isValid: boolean = true;

        if(control.value){
            if(!control.value.trim().endsWith('/mapperpi')){
                return {'URLDoesNotEndsWith': true};
            }else if(!control.value.trim().startsWith('http://') &&
                        !control.value.trim().startsWith('https://') ){
                return {'InvalidProtocol': true};
            }else {
                return null;
            }
        }else{
            return { 'required': true } ;
        }
    };
}

